import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { darken } from '@mui/material'
import { colors } from '@global/constants'

export const FabIconContainer = styled.div`
  flex-shrink: 1;
`

export const ButtonContainer = styled.div`
  position: relative;
`

export const buttonProgress = css`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
`

export const fab = css`
  position: relative;
  width: 38px;
  height: 38px;
  min-height: 38px;
  min-width: 38px;
  color: ${colors.white};
  box-shadow: none;
  border-radius: 20px;
`

export const disabled = css`
  color: rgba(0, 0, 0, 0.26);
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.12);

  &:hover {
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none;
    background-color: rgba(0, 0, 0, 0.12);
  }
`

export const editButton = css`
  min-width: 125px;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`

export const removeRowsIcon = css`
  background-color: ${colors.red.main};

  &:hover {
    background-color: ${darken(colors.red.main, 0.3)};
  }
`

export const duplicateRowsIcon = css`
  background-color: ${colors.blue.main};

  &:hover {
    background-color: ${darken(colors.blue.main, 0.3)};
  }
`

export const purple = css`
  background-color: ${colors.purple.main};

  &:hover {
    background-color: ${darken(colors.purple.main, 0.3)} !important;
  }
`

export const downloadMenu = css`
  z-index: 101;
`
